import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorkReportMeasuresDt from '@/services/dataTransferModules/workReportMeasuresDt'
import useRegulationMeasureTypes from '@/composables/staticData/useRegulationMeasureTypes'

export default function useWorkReportMeasures(params = {
	useLocalRefs: true,
	showErrorNotificationForLoadingAllEntities: true,
}) {

	const workReportMeasuresDt = new WorkReportMeasuresDt()

	const { t: $t } = useI18n()

	const {
		measureTypesEnum,
	} = useRegulationMeasureTypes()

	const defaults = {
		creatingWorkReportMeasure: {
			title: '',
			description: '',
			measure: '',
		},
		fieldsToPatch: ['title', 'description', 'measure'],
	}

	const {
		loadEntityFlags: flags,

		entities: workReportMeasures,
		getEntities: getWorkReportMeasures,

		entity: workReportMeasure,
		getEntity: getWorkReportMeasure,

		createEntity: createWorkReportMeasure,

		updateEntity: putWorkReportMeasure,

		patchEntity: updateWorkReportMeasures,

		deleteEntity: deleteWorkReportMeasure,
	} = useBlProviders(workReportMeasuresDt, Object.assign({
		postProcessEntityCallback: (el) => {
			const measureType = measureTypesEnum.value[el.measure]
			el.__ao__measure = measureType
			el.__ao__title = `${el.title}, ${measureType.title}`
			return el
		},

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Work report type loading error'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error creating work report measures'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Error while loading ypes of measurements'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Work measurement report editing error'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error when deleting the type of measurements'),
	}, params))

	return {
		flags,
		defaults,
		workReportMeasures,
		workReportMeasure,
		getWorkReportMeasures,
		getWorkReportMeasure,
		createWorkReportMeasure,
		putWorkReportMeasure,
		updateWorkReportMeasures,
		deleteWorkReportMeasure,
	}
}
